<div class="decision-report-step">
  <header class="step-topbar">
    <h1 class="step-topbar__title">
      {{ 'project.steps.decisionReport.stepTitle' | transloco }}
    </h1>
  </header>

  @if (!isStepPrerequisiteCompleted()) {
    <app-previous-step-incomplete-notice></app-previous-step-incomplete-notice>
  } @else {
    <main class="step-content">
      <p-button
        styleClass="export-button"
        [label]="'project.steps.decisionReport.generate' | transloco"
        icon="pi pi-cog"
        [loading]="isGenerating()"
        (onClick)="generateReport()"
      />

      @if (hasGeneratedReport()) {
        <div class="generated-report">
          <p-button
            styleClass="export-button"
            [label]="'project.steps.decisionReport.download' | transloco"
            icon="pi pi-download"
            [loading]="isDownloading()"
            (onClick)="downloadReport()"
          />
          <span class="generated-report__timestamp">
            {{ 'project.steps.decisionReport.generatedAt' | transloco }}
            {{ exportStatus()?.generatedAt | date: 'dd.MM.yyyy HH:mm' }}
          </span>
        </div>
      }
    </main>
  }
</div>
